<script setup lang="ts">
    import { ref, watch } from 'vue';
    import { __ } from '../stores/expressions';

    const props = withDefaults(
        defineProps<{
            id: string;
            items: string[];
            modelValue?: string;
            placeholder?: string;
            size?: 'small' | 'large';
        }>(),
        {
            modelValue: undefined,
            placeholder: undefined,
            size: 'large',
        }
    );

    const emit = defineEmits<{
        (e: 'update:modelValue', value: string): void;
        (e: 'update:items', value: string[]): void;
    }>();

    const localItems = ref<string[]>([]);
    const input = ref<HTMLInputElement | null>(null);

    // onMounted(() => {
    //     if (props.items) {
    //         items.value = props.items;
    //     }
    // });

    watch(
        () => props.items,
        (newItems) => {
            localItems.value = newItems;
        },
        { immediate: true, deep: true }
    );

    watch(
        () => input.value,
        (newValue) => {
            input.value = newValue;
        },
        { immediate: true }
    );

    const addItem = () => {
        if (!input.value || !input.value.value) {
            return;
        }

        if (!localItems.value.includes(input.value.value)) {
            localItems.value.push(input.value.value.trim());
        }

        emit('update:items', localItems.value);

        input.value.value = '';
    };

    const removeItem = (item: string) => {
        localItems.value = localItems.value.filter((i: string) => i !== item);
        emit('update:items', localItems.value);
    };

    const editItem = (item: string) => {
        if (input.value?.value.length === 0 && item) {
            input.value.value = item;
            removeItem(item);
        }
    };
</script>

<template>
    <div
        class="text-input border custom-focus-within flex flex-wrap items-center overflow-hidden p-1"
        :class="size === 'small' ? 'rounded-sm' : 'border-gray-dark'"
        @click="input!.focus()"
    >
        <button
            v-for="item in localItems"
            :key="item"
            class="bg-gray-lightest text-gray-dark cursor-pointer hover:bg-gray-light px-2.5 py-0.5 rounded-full m-0.5"
            :aria-label="__('remove-item', { item })"
            @click="removeItem(item)"
        >
            {{ item }}
        </button>
        <input
            :id="props.id"
            ref="input"
            type="text"
            :placeholder="placeholder"
            :aria-label="placeholder"
            class="border-0 focus:ring-0 flex-grow py-0.5 px-1.5 min-w-24 w-24"
            :class="{ 'text-caption': size === 'small' }"
            @keyup.backspace="editItem(localItems[localItems.length - 1])"
            @keyup.enter="addItem()"
            @blur="addItem()"
        />
    </div>
</template>
